import { html, render } from 'lit';
import { Entidad } from '../../../../data/Entidad';
import { IFinanzaCargoAplicado } from '../../../../data/entidad/Finanza';
import { IFinanzaAgrupadorCargos } from '../../../../data/entidad/FinanzaAgrupadorCargos';
import { MFinanzaEdoCtaMovimiento } from '../../../../data/model/FinanzaEstadoCuenta/MFinanzaEdoCtaMovimiento';
import { _DICC_ESCUELA } from '../../../../data/modulo/Escuela';
import { _DICC_AGRUPADORES_FULL, _SvFinanzasObtenerListaAgrupadorCargosByIds } from '../../../../data/modulo/FinanzaAgrupadorCargos';
import { _SvFinanzasObtenerCargoAplicadoPorID } from '../../../../data/modulo/FinanzasAsignaciones';
import _L from '../../../../util/Labels';
import '../../../components/Icon';
import { _ModalSimple } from '../../../controlD3/ModalThings/ModalSimple';
import { NotificacionV2 } from '../../../controlD3/NotificacionV2';
import '../../../controlWC/FileIcoComponent';
import '../../../controlWC/TooltipComponent';
import { UIUtilFormat } from '../../../util/Format';
import { UIUtilTime } from '../../../util/Time';
import { UIUtilViewData } from '../../../util/ViewData';


export function AlumnoEdoCtaMovDetalleCargoModal(idEscuela: number, movCargo: MFinanzaEdoCtaMovimiento) {
    _ModalSimple({
        Title: _L("panelfinanzasedocuenta.tag_info_cargo_title"),
        Width: 400,
        DrawContent: async (content, modalThings) => {
            content.classed("body_informacion", true);
            renderContent(idEscuela, content.node(), movCargo);

            modalThings.Progress.node()._Visible = true;
            _SvFinanzasObtenerCargoAplicadoPorID(movCargo.IdCargo)
                .then((res) => {
                    if (res.Resultado <= 0 || !res.Datos) {
                        return;
                    }
                    const cargoInfo = res.Datos;
                    renderContent(idEscuela, content.node(), movCargo, cargoInfo);
                })
                .catch(() => {
                    NotificacionV2._Mostrar(_L("general.notif_fail_infosync"), "ADVERTENCIA");
                })
                .finally(() => {
                    modalThings.Progress.node()._Visible = false;
                });
        }
    })
}

function renderContent(idEscuela: number, container: HTMLElement, movCargo: MFinanzaEdoCtaMovimiento, cargoAplicado?: IFinanzaCargoAplicado) {
    const c = cargoAplicado;
    const recargoMorosidad: number = movCargo._CalcularAdeudoRecargoPendiente();
    const escuelaUsaFacturacion: boolean = !!_DICC_ESCUELA.get(idEscuela)?.UsaFactura;
    const getAgrupadorCargo: () => IFinanzaAgrupadorCargos = () => (c?.IdAgrupador > 0 ? _DICC_AGRUPADORES_FULL.get(idEscuela)?.get(c.IdAgrupador) : null);
    const usaRecargo: boolean = (!!c && c.TipoRecargo != Entidad.CFinanzaCargoTipoValor.Ninguno);
    // const onClickRecargoInfo = (e: Event) => AlumnoEdoCtaMovDetalleGeneralModal("morosidad", ???);

    const renderContent = () => render(html`
        <label><b>${_L("panelfinanzasedocuenta.tag_descript")}</b>: ${movCargo.Cargo || _L("general.nodisponible")}</label>
        <label><b>${_L("panelfinanzasedocuenta.d_field_saldo")}</b>: ${UIUtilFormat._CurrencyFmt(movCargo._ObtenerSaldoFinal())}</label>
        <label><b>${_L("panelfinanzasedocuenta.tag_periodic")}</b>: ${UIUtilViewData._GetStr_Periodicidad(movCargo.Periodicidad)}</label>
        <label><b>${_L("panelfinanzasedocuenta.tag_fechaaplica")}</b>: ${UIUtilTime._DateFormatStandar(movCargo.FechaAplicacion, "d MMM yyyy")}</label>
        <label><b>${_L("panelfinanzasedocuenta.tag_fechavence")}</b>: ${UIUtilTime._DateFormatStandar(movCargo.FechaVencimiento, "d MMM yyyy")}</label>
        ${usaRecargo || recargoMorosidad > 0
            ? html`
            <label><b>${_L("panelfinanzasedocuenta.tag_fechamorosidad")}</b>: ${UIUtilTime._DateFormatStandar(movCargo.FechaMorosidad, "d MMM yyyy")}</label>
            <label><b>${_L("panelfinanzasedocuenta.tag_recargomoroso")}</b>: ${UIUtilFormat._CurrencyFmt(recargoMorosidad)}</label>
        `
            : html`
            <label><b>${_L("finanzascargo.tag_recgs")}</b>: ${_L("general.noaplica_short")}</label>
        `}

        ${escuelaUsaFacturacion && cargoAplicado
            ? html`
        <label><b>${_L("general.nota")}</b>: ${_L("finanzascargo.tag_escuela_usa_fact", _DICC_ESCUELA.get(idEscuela)?.Nombre || "-")}</label>
        <fieldset class="info_fiscal_details">
            <legend>${_L("finanzascargo.frm1_cfg_fiscal")}</legend>
            <label><b>${_L("finanzascargo.frm1_agrupador")}</b>: ${c.IdAgrupador > 0 ? getAgrupadorCargo()?.Prefix || _L("general.nodisponible") : _L("general.noaplica_short")}</label>
            <label><b>${_L("finanzascargo.frm1_claveprodservsat")}</b>: ${((c.ClaveProdServSAT || "") + " " + (c.NombreProdServSAT || "")).trim() || _L("general.noaplica_short")}</label>
            <label><b>${_L("finanzascargo.frm1_claveunidadsat")}</b>: ${((c.ClaveUnidadSAT || "") + " " + (c.NombreUnidadSAT || "")).trim() || _L("general.noaplica_short")}</label>
            <label><b>${_L("finanzascargo.frm1_complemento_iedu_requerido")}</b>: ${c.ComplementoRequerido ? _L("general.afirma") : _L("general.niega")}</label>
        </fieldset>
        `
            : null}
    `, container);

    renderContent();

    if (idEscuela > 0 && c?.IdAgrupador > 0) {
        _SvFinanzasObtenerListaAgrupadorCargosByIds(idEscuela, [c.IdAgrupador]).then(() => {
            renderContent();
        });
    }
}